import { onBlurRuleSet } from './Validation/rules/ruleSets/onBlurRuleSet';
import { unmaskValue } from './utils/unmaskValue';
import { interstateInputEventBuilder } from '../InterstateEvents';
import { onBlurMultilineSet } from './Validation/rules/ruleSets/onBlurMultilineSet';
export const handleOnBlur = (validator, validationParameters, readOnly, disabled, onBlur, onChange) => event => {
  if (readOnly || disabled) {
    validator.reset();
    return;
  }
  const unmaskedValue = unmaskValue(event.target.value, validationParameters.masking);
  const ruleSet = validationParameters.multiline ? onBlurMultilineSet : onBlurRuleSet;
  const validationState = validator.validate(unmaskedValue, validationParameters, ruleSet, true);
  if (onBlur) {
    onBlur(interstateInputEventBuilder(validationParameters.name, unmaskedValue, validationState.isValid, event, validationParameters.label, validationState.messageKey));
  }
  if (onChange) {
    onChange(interstateInputEventBuilder(validationParameters.name, unmaskedValue, validationState.isValid, event, validationParameters.label, validationState.messageKey));
  }
};